import { render, staticRenderFns } from "./ModalUpdateChatbot.vue?vue&type=template&id=55e31a37&scoped=true&"
import script from "./ModalUpdateChatbot.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateChatbot.vue?vue&type=script&lang=js&"
import style0 from "./ModalUpdateChatbot.vue?vue&type=style&index=0&id=55e31a37&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e31a37",
  null
  
)

export default component.exports